<template>
    <AppLayout page="/myschedule" pageTitle="Booking">
        <v-container class="h-full">
            <v-row class="h-full">
                <v-col class="pa-0">
                    <v-card flat class="soli-grey soli-round">
                        <v-card-title class="pb-0">Service</v-card-title>
                        <v-chip-group v-model="form.type" center-active
                            ><v-chip
                                v-for="(chip, idx) in bookingTypes"
                                :key="idx"
                                outlined
                                active-class="primary--text"
                                :class="{
                                    'ml-3': idx == 0,
                                    'mr-3': bookingTypes.length - 1 == idx,
                                }"
                                >{{ chip }}</v-chip
                            ></v-chip-group
                        >
                    </v-card>
                    <v-card flat class="soli-grey soli-round">
                        <v-card-title class="pb-0">Who</v-card-title>
                        <v-chip-group v-model="form.who" center-active
                            ><v-chip
                                v-for="(chip, idx) in relationships"
                                :key="idx"
                                outlined
                                active-class="primary--text"
                                :class="{
                                    'ml-3': idx == 0,
                                    'mr-3': relationships.length - 1 == idx,
                                }"
                                >{{ chip.name }}</v-chip
                            ></v-chip-group
                        >
                    </v-card>
                    <!--<v-card flat class="soli-grey soli-round"
                        ><v-card-title>Who</v-card-title></v-card
                    >
                    <v-card flat class="soli-grey soli-round"
                        ><v-card-title>Purchase Option</v-card-title></v-card
                    >
                    <v-card flat class="soli-grey soli-round"
                        ><v-card-title>Credit(s)</v-card-title></v-card
                    >-->
                    <v-card flat class="soli-grey soli-round">
                        <v-card-title>When</v-card-title>
                        <BookingAvailability
                            :errors="errors"
                            :instrument="{ name: 'Guitar', id: 1 }"
                        />
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </AppLayout>
</template>
<script>
import BookingAvailability from "../../Components/MySchedule/Booking/BookingAvailability.vue";
import AppLayout from "../../Layouts/AppLayout";

export default {
    components: {
        AppLayout,
        BookingAvailability,
    },
    props: {
        errors: {
            type: Object,
            default: () => {},
        },
        relationships: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            bookingTypes: [
                "Assessment",
                "Weekly Lesson",
                "Reschedule",
                "Drop-in",
                "Event",
            ],
            form: {
                type: 0,
                who: 0,
            },
        };
    },
};
</script>
